module.exports = __webpack_public_path__ + "img/Nora-blueprint.a8305b.png";